import type { Components, Theme } from '@mui/material/styles';
import { baselineOverrides } from './baseline';
import { dataOverrides } from './data';
import { inputOverrides } from './inputs';
import { navigationOverrides } from './navigation';
import { surfaceOverrides } from './surfaces';

export function componentOverrides(theme: Theme): Components<Theme> {
  return {
    ...baselineOverrides(theme),
    ...surfaceOverrides(theme),
    ...inputOverrides(theme),
    ...navigationOverrides(theme),
    ...dataOverrides(theme),
  };
}
